// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE

import * as Pervasives from "bs-platform/lib/es6/pervasives.js";

function trigger(envelope) {
  var match = envelope.envelopeParams;
  var attack = match.attack;
  var decay = match.decay;
  var sustain = match.sustain;
  var targetValue = match.targetValue;
  var currentTime = envelope.audioContext.getOutputTimestamp();
  var attackTime = currentTime.contextTime + attack;
  envelope.targetParam.cancelScheduledValues(currentTime.contextTime);
  envelope.targetParam.setTargetAtTime(targetValue, currentTime.contextTime + Pervasives.epsilon_float, attack / 3.0);
  envelope.targetParam.setTargetAtTime(sustain * targetValue, attackTime, decay / 3.0);
  
}

function endTrigger(envelope) {
  var match = envelope.envelopeParams;
  var release = match.release;
  var currentTime = envelope.audioContext.getOutputTimestamp();
  envelope.targetParam.cancelScheduledValues(currentTime.contextTime);
  envelope.targetParam.setTargetAtTime(Pervasives.epsilon_float, currentTime.contextTime, release / 3.0);
  
}

function update(param, envelope) {
  var envelopeParams = envelope.envelopeParams;
  switch (param.TAG | 0) {
    case /* Attack */0 :
        envelopeParams.attack = param._0;
        return ;
    case /* Decay */1 :
        envelopeParams.decay = param._0;
        return ;
    case /* Sustain */2 :
        envelopeParams.sustain = param._0;
        return ;
    case /* Release */3 :
        envelopeParams.release = param._0;
        return ;
    case /* TargetValue */4 :
        envelopeParams.targetValue = param._0;
        return ;
    
  }
}

function make(targetValueOpt, targetParam, audioCtx) {
  var targetValue = targetValueOpt !== undefined ? targetValueOpt : 1.0;
  targetParam.value = Pervasives.epsilon_float;
  var envelopeParams = {
    attack: 0.2,
    decay: 0.3,
    sustain: 0.1,
    release: 1.0,
    targetValue: targetValue
  };
  return {
          envelopeParams: envelopeParams,
          targetParam: targetParam,
          audioContext: audioCtx
        };
}

var defaultAttack = 0.2;

var defaultDecay = 0.3;

var defaultSustain = 0.1;

var defaultRelease = 1.0;

export {
  defaultAttack ,
  defaultDecay ,
  defaultSustain ,
  defaultRelease ,
  trigger ,
  endTrigger ,
  update ,
  make ,
  
}
/* No side effect */
